// APEX RACING — Carrousel v5.1

if (typeof window.apexCarouselLoaded === 'undefined') {
  window.apexCarouselLoaded = true;


// ── Carrousel ────────────────────────────────────────────────────────────────
const CARD_W = 280 + 16; // card width + gap
let carouselIdx = 0;
const cards = document.querySelectorAll('.realCard');
const track = document.getElementById('carouselTrack');
const dotsEl = document.getElementById('carouselDots');
const visibleCount = Math.floor((window.innerWidth > 900 ? (window.innerWidth - 96) / CARD_W : window.innerWidth / CARD_W));
const maxIdx = Math.max(0, cards.length - visibleCount);

// Créer les dots
cards.forEach((_, i) => {
  if (i <= maxIdx) {
    const d = document.createElement('div');
    d.style.cssText = `width:8px;height:8px;border-radius:50%;background:${i===0?'var(--red)':'var(--gray-mid)'};transition:all .3s;cursor:pointer;`;
    d.onclick = () => carouselGo(i);
    dotsEl.appendChild(d);
  }
});

function carouselGo(idx) {
  carouselIdx = Math.max(0, Math.min(idx, maxIdx));
  track.style.transform = `translateX(-${carouselIdx * CARD_W}px)`;
  dotsEl.querySelectorAll('div').forEach((d, i) => {
    d.style.background = i === carouselIdx ? 'var(--red)' : 'var(--gray-mid)';
    d.style.width = i === carouselIdx ? '24px' : '8px';
  });
  window.carouselNext = carouselNext;
  window.carouselPrev = carouselPrev;
  window.carouselGo   = carouselGo;
}
function carouselNext() { carouselGo(carouselIdx + 1); }
function carouselPrev() { carouselGo(carouselIdx - 1); }

// Swipe tactile
let touchStartX = 0;
track.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, {passive:true});
track.addEventListener('touchend', e => {
  const diff = touchStartX - e.changedTouches[0].clientX;
  if (Math.abs(diff) > 50) diff > 0 ? carouselNext() : carouselPrev();
}, {passive:true});


}
